import React from 'react';
import PropTypes from 'prop-types';
import { FeatureFlagsProvider } from '@lms/react-configuration/context/feature-flags';
import { acquireAccessToken } from '../../authentication/authConfig';

const FeatureFlagWrapper = ({ children }) => {
  const configurationApiBaseAddress = window?.config?.configurationApiBaseAddress;

  return (
    <FeatureFlagsProvider
      url={configurationApiBaseAddress}
      getAccessToken={acquireAccessToken}
      featurePrefix="Consent.UI."
    >
      {children}
    </FeatureFlagsProvider>
  );
};

FeatureFlagWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FeatureFlagWrapper;
